module.exports = __webpack_public_path__ + "9f65a5aade8cc1ef0ff7bc0293eb0404.png";